<template>
  <div ref="chart" style="width: 100vw; height: 200px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'PieChart',
  props: {
    value: {
      type: [Number, String],
      required: true,
      default: 0 
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#1890ff'
    },
    total: {
      type: Number,
      default: 100
    },
    showIcon: {
      type: String,
      default: '%'
    },
  },
  data() {
    return {
      chart: null,
      option: {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.value}`;
          }.bind(this)
        },
        title: [
          {
            textStyle: {
              fontSize: 14,
              color: '#333'
            },
            subtextStyle: {
              color: '#333',
              fontSize: 14,
              fontWeight: 'bold'
            },
            left: '20%',
            top: '15%',
            textAlign: 'center',
            rich: {
              a: {
                fontSize: 14,
                color: '#333'
              },
              b: {
                fontSize: 12,
                color: '#999'
              }
            }
          }
        ],
        series: [
          {
            name: this.name,
            type: 'pie',
            hoverAnimation: false,
            radius: ['50%', '70%'],
            data: []
          }
        ]
      }
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.updateChart();
    },
    updateChart() {
      if (!this.chart) return; //确保 this.chart 不为 null
      const { value, name, color, total,showIcon } = this;
      this.option.series[0].data = [
        {
          value,
          name,
          label: {
            show: true,
            position: 'center',
            formatter: `{b|{b}}\n{d|{d}}${showIcon}`,
            rich: {
              b: {
                fontSize: 14,
                lineHeight: 30,
                color: '#333'
              },
              d: {
                fontSize: 24,
                color: '#333',
                fontWeight: 'bold'
              }
            },
            color: '#333'
          },
          itemStyle: {
            normal: {
              color: color
            }
          }
        },
        {
          value: total - value, // 使用 total 计算剩余值
          itemStyle: {
            normal: {
              color: '#F0F2F5'
            }
          }
        }
      ];
      this.chart.setOption(this.option);
    }
  },
  watch: {
    value: {
      handler() {
        this.updateChart();
      },
      immediate: true
    },
    name: {
      handler() {
        this.updateChart();
      },
      immediate: true
    },
    total: {
      handler() {
        this.updateChart();
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/dataBoard/components/Pie.vue